import { Checkbox } from 'antd';
import { Device } from '../../../../../../../../../types/Device';
import useLayoutPositionsStore from '../../../../api/layoutPositions/layoutPositions';
import useRecordingStore from '../../../../api/recording/recordingStore';
import { RecordingTimer } from './components/RecordingTimer/RecordingTimer';

interface DeviceTileProps {
    device: Device;
    isSelected: boolean;
    isDisabled?: boolean;
    tooltip?: string;
    highlight?: 'audio' | 'video' | 'photo';
    onTileClick: (device: Device) => void;
}

export const DeviceTime: React.FC<DeviceTileProps> = ({
    device,
    isSelected,
    isDisabled = false,
    tooltip,
    highlight,
    onTileClick,
}) => {
    const { getPosition } = useLayoutPositionsStore();
    // const startTime = useRecordingStore((state) => state.getDeviceRecordingStartTime(device.UID));
    const layoutIndex = getPosition(device.UID) ?? 0;

    return (
        <div
            style={{
                aspectRatio: '16/9',
                position: 'relative',
                backgroundColor: 'var(--gray-01)',
                borderRadius: '8px',
                border:
                    highlight === 'video'
                        ? '2px solid var(--warning)'
                        : highlight === 'audio'
                          ? '2px solid var(--warning)'
                          : isSelected
                            ? '2px solid var(--tertiary-dark)'
                            : 'none',
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
            onClick={() => !isDisabled && onTileClick(device)}
        >
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'rgba(255, 255, 255, 0.7)',
                    zIndex: 1,
                }}
            >
                {layoutIndex + 1}
            </div>

            {/*{tooltip && startTime && (*/}
            {/*    <RecordingTimer className={'recording-status-tooltip'} deviceUID={device.UID} />*/}
            {/*)}*/}

            <div style={{ padding: '4px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Checkbox
                        checked={isSelected}
                        disabled={isDisabled}
                        onChange={(e) => {
                            e.stopPropagation();
                            onTileClick(device);
                        }}
                        className={'checkbox-camera'}
                        style={{ marginRight: 4 }}
                    />
                    <span
                        style={{
                            fontSize: '12px',
                            color: 'white',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            paddingTop: 2,
                        }}
                    >
                        {device.name}
                    </span>
                </div>
            </div>
        </div>
    );
};
